<template>
  <section :class="{playing: state}" class="d_i-f im-music-player" @click="onSwitch">
    <audio
      ref="sound"
      :src="src"
      loop
      @play="_onplay"
      @pause="_onpause" />
  </section>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    isAutoPlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      Tag: 'MusicPlayer',
      isInit: false,
      // 状态
      state: false,
      // 是否关闭 - 主动关闭为true
      isClose: false
    }
  },
  created() {
    if (this.isAutoPlay) {
      if (/MicroMessenger/.test(window.navigator.userAgent)) {
        document.addEventListener('WeixinJSBridgeReady', () => {
          this.initMusic()
        }, false)
      } else {
        this.initMusic()
      }
    }
  },
  methods: {
    initMusic() {
      this.$nextTick(_ => {
        const setInitMuisc = () => {
          this.play()

          document.removeEventListener('click', setInitMuisc)
          document.removeEventListener('touchstart', setInitMuisc)
        }
        document.addEventListener('click', setInitMuisc)
        document.addEventListener('touchstart', setInitMuisc)

        document.body.click()
        this.isInit = true
      })
    },
    _onplay() {
      this.state = true
      this.$emit('play')
    },
    _onpause() {
      this.state = false
      this.$emit('pause')
    },
    onSwitch() {
      this.onChangeMusic(!this.state)
      this.isClose = this.state
    },
    onChangeMusic(state) {
      if (!this.src) return
      state ? this.$refs.sound.play() : this.$refs.sound.pause()
    },
    play() {
      this.onChangeMusic(true)
    },
    pause() {
      this.onChangeMusic(false)
    }
  }
}
</script>
